var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"mt-15",attrs:{"cols":"12","align":"center","justify":"center"}},[_c('div',{staticClass:"video-panel",attrs:{"id":"video-panel"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }